// const [dataFood, setDataFood] = useState({
//     data: [],
//     panigation: { pageSize: 1, page: 1 },
//   });

const Pagination = ({
  pageSize,
  setDataFood,
  dataFood = {},
  render,
  setRender,
}) => {
  const handleFilterPage = (index) => {
    setRender(!render);
    setDataFood({ ...dataFood, panigation: { pageSize, page: index + 1 } });
    window.scroll({
      top: "0px",
      behavior: "smooth",
    });
  };

  const handleNextPage = () => {
    setRender(!render);
    if (dataFood.panigation?.page !== 1) {
      setDataFood({
        ...dataFood,
        panigation: { pageSize, page: dataFood.panigation.page - 1 },
      });
      window.scroll({
        top: "0px",
        behavior: "smooth",
      });
    }
  };

  const handlePrevPage = () => {
    setRender(!render);
    if (pageSize !== dataFood.panigation?.page) {
      setDataFood({
        ...dataFood,
        panigation: { pageSize, page: dataFood.panigation.page + 1 },
      });
      window.scroll({
        top: "0px",
        behavior: "smooth",
      });
    }
  };

  const renderPage = () => {
    const listPage = [];
    for (let index = 0; index < pageSize; index++) {
      listPage.push(
        <li
          key={index}
          onClick={() => handleFilterPage(index)}
          style={
            index + 1 === dataFood.panigation.page
              ? { color: "white", backgroundColor: "#ca6f04" }
              : {}
          }
          className="h-9 w-9 font-semibold cursor-pointer border border-slate-200 hover:bg-primaryLight hover:text-white rounded flex justify-center items-center relative transition"
        >
          {index + 1}
        </li>
      );
    }
    return listPage;
  };

  return (
    <div className="w-full text-center">
      {pageSize ? (
        <ul className="flex justify-center items-center gap-6 my-11">
          <li
            className="text-sm font-semibold border rounded p-1 px-2 cursor-pointer hover:bg-slate-300"
            style={
              dataFood.panigation.page === 1
                ? { pointerEvents: "none", opacity: "0.5" }
                : null
            }
            onClick={handleNextPage}
          >
            Prev
          </li>
          <div className="flex  flex-wrap gap:1 sm:gap-3">{renderPage()}</div>
          <li
            className="text-sm font-semibold border rounded p-1  px-2  cursor-pointer hover:bg-slate-300"
            style={
              pageSize === dataFood.panigation.page
                ? { pointerEvents: "none", opacity: "0.5" }
                : null
            }
            onClick={handlePrevPage}
          >
            Next
          </li>
        </ul>
      ) : (
        <div className="text-red font-bold text-lg mt-3">
          Không có sản phẩm nào.
        </div>
      )}
    </div>
  );
};

export default Pagination;
